<template>
  <div
    :class="{ 'b-read-only-text-field--error': this.errorMessages.length > 0 }"
  >
    <div v-if="label && inlineReadOnly">{{ label }}: {{ value || '-' }}</div>
    <div v-else-if="label && !inlineReadOnly" class="b-read-only-text-field">
      <h5 v-if="label">{{ label }}</h5>
      <label>{{ (value || '-') + (suffix ? ' ' + suffix : '') }}</label>
    </div>
    <label v-else>{{ (value || '-') + (suffix ? ' ' + suffix : '') }}</label>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: null,
    inlineReadOnly: Boolean,
    errorMessages: { type: Array, default: () => [] },
    suffix: String
  }
};
</script>

<style lang="scss">
.b-read-only-text-field {
  min-height: 44px;

  &--error label {
    color: var(--v-error-base);
  }
}
</style>
